<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-sack-dollar"></i></div>
      <div>
        Budget prévisionnel
        <div class="page-title-subheading">Gestion des recettes et dépenses prévisionnelles de l'établissement</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<!-- Synthèse -->
@if (summary) {
  <div class="row mb-3">
    <div class="col-md-3">
      <div class="card mb-2 widget-content bg-success">
        <div class="widget-content-wrapper text-white">
          <div class="widget-content-left">
            <div class="widget-heading">Recettes prévues</div>
            <div class="widget-subheading">Réalisé : {{summary.recettes_realisees | number}} F</div>
          </div>
          <div class="widget-content-right">
            <div class="widget-numbers text-white"><span>{{summary.recettes_prevues | number}} F</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card mb-2 widget-content bg-danger">
        <div class="widget-content-wrapper text-white">
          <div class="widget-content-left">
            <div class="widget-heading">Dépenses prévues</div>
            <div class="widget-subheading">Réalisé : {{summary.depenses_realisees | number}} F</div>
          </div>
          <div class="widget-content-right">
            <div class="widget-numbers text-white"><span>{{summary.depenses_prevues | number}} F</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card mb-2 widget-content"
           [ngClass]="summary.solde_previsionnel >= 0 ? 'bg-arielle-smile' : 'bg-grow-early'">
        <div class="widget-content-wrapper text-white">
          <div class="widget-content-left">
            <div class="widget-heading">Solde prévisionnel</div>
            <div class="widget-subheading">Recettes − Dépenses</div>
          </div>
          <div class="widget-content-right">
            <div class="widget-numbers text-white"><span>{{summary.solde_previsionnel | number}} F</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card mb-2 widget-content bg-night-sky">
        <div class="widget-content-wrapper text-white">
          <div class="widget-content-left">
            <div class="widget-heading">Solde réalisé</div>
            <div class="widget-subheading">{{summary.lignes}} ligne(s)</div>
          </div>
          <div class="widget-content-right">
            <div class="widget-numbers text-white"><span>{{summary.solde_realise | number}} F</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<div class="main-card mb-3 card">
  <div class="card-body">

    <div class="d-flex justify-content-between mb-3">
      <div class="btn-group">
        @if (buttonsPermission?.add) {
          <button class="btn btn-danger" (click)="add(formContent)">
            <i class="fa-solid fa-sack-dollar"></i> Nouvelle ligne
          </button>
        }
        @if (selected_data && buttonsPermission?.edit) {
          <button class="btn btn-outline-primary" (click)="edit(formContent)">Modifier</button>
        }
        @if (selected_data && buttonsPermission?.delete) {
          <button class="btn btn-outline-danger" (click)="delete()">Supprimer</button>
        }
      </div>
      <input type="text" class="form-control w-25" [(ngModel)]="search_text" placeholder="Rechercher...">
    </div>

    <app-loading [isVisible]="loading"></app-loading>

    <table class="table table-hover table-striped">
      <thead>
        <tr>
          <th style="width:10px"></th>
          <th>Libellé</th>
          <th>Catégorie</th>
          <th>Rubrique</th>
          <th class="text-end">Prévu (F)</th>
          <th class="text-end">Réalisé (F)</th>
          <th class="text-center">Exécution</th>
          <th class="text-center">Statut</th>
        </tr>
      </thead>
      <tbody>
        @for (d of data | sampleSearch:search_text:'label' | paginate:{id:'budgetPg', itemsPerPage:pg.pageSize, currentPage:pg.p, totalItems:pg.total}; track d.id) {
          <tr>
            <td><input type="radio" [checked]="selected_data?.id === d.id" name="budgetRadio" (click)="checked(d)"></td>
            <td class="fw-bold">{{d.label}}</td>
            <td>
              <span class="badge" [ngClass]="d.category === 'recette' ? 'bg-success' : 'bg-danger'">
                {{categoryLabel(d.category)}}
              </span>
            </td>
            <td>{{d.rubric || '—'}}</td>
            <td class="text-end">{{d.planned_amount | number}}</td>
            <td class="text-end">{{d.actual_amount | number}}</td>
            <td class="text-center" style="min-width:120px">
              <div class="progress" style="height:16px">
                <div class="progress-bar"
                     [ngClass]="executionRate(d) > 100 ? 'bg-warning' : 'bg-info'"
                     [style.width.%]="executionRate(d) > 100 ? 100 : executionRate(d)">
                  {{executionRate(d)}}%
                </div>
              </div>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="d.status == 1 ? 'bg-success' : 'bg-secondary'">
                {{d.status == 1 ? 'Ouvert' : 'Clôturé'}}
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (!loading && data.length === 0) {
      <p class="text-center text-muted py-4">Aucune ligne budgétaire. Créez votre première ligne.</p>
    }

    <div class="d-flex justify-content-center">
      <pagination-controls id="budgetPg" (pageChange)="getPage($event)"
                           [previousLabel]="'Précédent'" [nextLabel]="'Suivant'" [autoHide]="true">
      </pagination-controls>
    </div>
  </div>
</div>

<!-- Modal formulaire -->
<ng-template #formContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title">{{form.id ? 'Modifier' : 'Nouvelle'}} ligne budgétaire</h5>
    <button type="button" class="btn-close" (click)="d('x')"></button>
  </div>
  <form #f="ngForm" (ngSubmit)="form.id ? update(form) : store(form)">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-8 mb-3">
          <label class="form-label">Libellé *</label>
          <input name="label" class="form-control" [(ngModel)]="form.label" required placeholder="Ex: Frais de scolarité, Salaires enseignants...">
        </div>
        <div class="col-md-4 mb-3">
          <label class="form-label">Catégorie *</label>
          <select name="category" class="form-select" [(ngModel)]="form.category" required>
            @for (c of CATEGORIES; track c.value) { <option [value]="c.value">{{c.label}}</option> }
          </select>
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Rubrique</label>
          <input name="rubric" class="form-control" [(ngModel)]="form.rubric" placeholder="Ex: Salaires, Fournitures...">
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Exercice</label>
          <select name="academic_year_id" class="form-select" [(ngModel)]="form.academic_year_id">
            <option [ngValue]="null">— Exercice en cours —</option>
            @for (ay of ays; track ay.id) { <option [ngValue]="ay.id">{{ay.label || ay.name}}</option> }
          </select>
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Montant prévu (FCFA) *</label>
          <input name="planned_amount" type="number" min="0" class="form-control" [(ngModel)]="form.planned_amount" required>
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Montant réalisé (FCFA)</label>
          <input name="actual_amount" type="number" min="0" class="form-control" [(ngModel)]="form.actual_amount">
        </div>
        <div class="col-12 mb-2">
          <label class="form-label">Description</label>
          <textarea name="description" class="form-control" rows="2" [(ngModel)]="form.description"></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="d('x')">Annuler</button>
      <button type="submit" class="btn btn-danger" [disabled]="f.invalid || loading">
        Enregistrer <app-loading [isVisible]="loading"></app-loading>
      </button>
    </div>
  </form>
</ng-template>
